import {useEffect, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const useDataProcessor = (data, config, selectedTab = null) => {
  const {pathname} = useLocation();
  const [dataState, setDataState] = useState([]);
  const processedData = useMemo(() => {
    if (!data) return [];
    return data.map((item) => {
      const processedItem = {};
      Object.entries(config).forEach(([key, value]) => {
        processedItem[key] = typeof value === 'function' ? value(item) : getNestedValue(item, value);
      });
      return processedItem;
    });
  }, [data, config, getNestedValue]);

  useEffect(() => {
    setDataState(processedData);
  }, [processedData, pathname, selectedTab]);

  return {dataState, setDataState};
};
